import { createTermTagManager } from '../../utils/createTermTagManager';

export const agentCallsForbiddenTagManager = createTermTagManager({
  jsonQueryKey: 'cl',
  label: 'Без «Агентам не звонить»',
  id: 'cl',
});
